import {
  Access,
  AttendanceStatus,
  Gender,
  RequestStatus,
  WeekDay
} from '@/utils/types';

// Clinic schema
export interface Clinic {
  id?: string;
  name?: string | null;
  mobile_number: string | null;
  language?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export const CLINIC_COLUMNS = {
  ID: 'id',
  NAME: 'name',
  MOBILE_NUMBER: 'mobile_number',
  LANGUAGE: 'language',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at'
};

// ClinicGroup schema
export interface ClinicGroup {
  code: string;
  name: string;
  branch_clinic_ids: string[];
}

export const CLINIC_GROUP_COLUMNS = {
  CODE: 'code',
  NAME: 'name',
  BRANCH_CLINIC_IDS: 'branch_clinic_ids'
};

// Dentist schema
export interface Dentist {
  id?: string;
  first_name: string;
  last_name: string;
  clinic_id: string;
  created_at?: string;
  updated_at?: string;
  mobile_number?: string;
  user_id?: string;
  access?: Access | null;
  patient_verification_enabled?: boolean;
  specialization?: string | null;
}

export const DENTIST_COLUMNS = {
  ID: 'id',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  CLINIC_ID: 'clinic_id',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  MOBILE_NUMBER: 'mobile_number',
  USER_ID: 'user_id',
  ACCESS: 'access',
  PATIENT_VERIFICATION_ENABLED: 'patient_verification_enabled',
  SPECIALIZATION: 'specialization'
};

// Dentist Hours schema
export interface DentistHour {
  dentist_id?: string;
  day: WeekDay;
  start_time: string | null;
  end_time: string | null;
  open: boolean;
  created_at?: string;
  updated_at?: string;
}

export const DENTIST_HOUR_COLUMNS = {
  DENTIST_ID: 'dentist_id',
  DAY: 'day',
  START_TIME: 'start_time',
  END_TIME: 'end_time',
  OPEN: 'open',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  ID: 'id'
};

// Patient schema
export interface Patient {
  id?: string;
  first_name: string | null;
  last_name: string | null;
  mobile_number: string | null;
  gender: Gender | null;
  birthday: string | null;
  created_at?: string;
  updated_at?: string;
  is_user?: boolean;
  user_id?: string | null;
  dentist_id?: string | null;
}

export const PATIENT_COLUMNS = {
  ID: 'id',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  MOBILE_NUMBER: 'mobile_number',
  GENDER: 'gender',
  BIRTHDAY: 'birthday',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  IS_USER: 'is_user',
  USER_ID: 'user_id',
  DENTIST_ID: 'dentist_id'
};

// Request schema
export interface Request {
  id?: string;
  date: string | null;
  start_time: string | null;
  end_time: string | null;
  purpose: string | null;
  status: RequestStatus;
  created_at?: string;
  updated_at?: string;
  dentist_id: string | null;
  patient_id: string | null;
  cancel_reason?: string | null;
  code?: string | null;
  reschedule_reason?: string | null;
  decline_reason?: string | null;
  attendance_status?: AttendanceStatus | null;
  hmo_provider?: string | null;
}

export const REQUEST_COLUMNS = {
  ID: 'id',
  DATE: 'date',
  START_TIME: 'start_time',
  END_TIME: 'end_time',
  PURPOSE: 'purpose',
  STATUS: 'status',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  DENTIST_ID: 'dentist_id',
  PATIENT_ID: 'patient_id',
  CANCEL_REASON: 'cancel_reason',
  CODE: 'code',
  RESCHEDULE_REASON: 'reschedule_reason',
  DECLINE_REASON: 'decline_reason',
  ATTENDANCE_STATUS: 'attendance_status',
  HMO_PROVIDER: 'hmo_provider'
};

// Service schema
export interface Service {
  id?: string;
  name: string;
  duration: number;
  dentist_id?: string | null;
}

export const SERVICE_COLUMNS = {
  ID: 'id',
  NAME: 'name',
  DURATION: 'duration',
  DENTIST_ID: 'dentist_id'
};

// Share schema
export interface Share {
  code: string;
  created_at: string;
  clinic_id: string;
}

export const SHARE_COLUMNS = {
  CODE: 'code',
  CREATED_AT: 'created_at',
  CLINIC_ID: 'clinic_id'
};
